import { type Stop } from '../domain/Stop'
import { isEmpty, isString } from '../utils/string'
import { type Nullable } from '../utils/types/Nullable'

export function mapStopToString(stop?: Nullable<Stop>): string | undefined {
  if (stop != null) {
    const { city, state, country, zipCode } = stop

    let result: Array<string> = []

    if (city) result.push(city)
    if (state) result.push(state)
    if (country) result.push(country)
    if (zipCode) result.push(zipCode)

    return result.join(',')
  }
}

export function mapStringToStop(stop?: Nullable<string>): Stop | undefined {
  if (!isString(stop) || isEmpty(stop)) {
    return
  }

  const [city, state, country, zipCode] = stop.split(',')
  const hasCity = isString(city) && !isEmpty(city)
  const hasState = isString(state) && !isEmpty(state)
  const hasCountry = isString(country) && !isEmpty(country)
  const hasZipCode = isString(zipCode) && !isEmpty(zipCode)

  // City and State are required
  if (!hasCity || !hasState) {
    return
  }

  return {
    city: city.trim(),
    state: state.trim(),
    country: hasCountry ? country.trim() : undefined,
    zipCode: hasZipCode ? zipCode.trim() : undefined,
  }
}
